import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const player_portals_grid_page_column = (
  page: PLAYER_PORTALS_MODELS.GridPageColumn,
) => {
  return {
    content: page.elements?.content.linkedItems ?? [],
  };
};

export default player_portals_grid_page_column;
